<template>
  <b-row>
    <div class="col-12 col-sm-9">
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <b-row>
            <div class="col-6">
              <b-form-group label="Client:">
                <b-v-select
                  id="form-input-brandId"
                  name="form-input-brandId"
                  v-validate="{ required: true }"
                  :state="validateState('form-input-brandId')"
                  v-model="itemForm.brandId"
                  :searchable="true"
                  :options="brandsList"
                />
                <b-form-invalid-feedback id="form-input-brandId-feedback">
                  {{ veeErrors.first('form-input-brandId') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group label="Name:">
                <b-form-input
                  id="form-input-name"
                  name="form-input-name"
                  v-validate="{ required: true, max: 200 }"
                  :state="validateState('form-input-name')"
                  v-model="itemForm.name"
                  placeholder="Enter a name for this rate shop"
                />
                <b-form-invalid-feedback id="form-input-name-feedback">
                  {{ veeErrors.first('form-input-name') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </b-row>

          <b-row>
            <div class="col-6">
              <b-form-group label="Filter by Max Delivery Days:">
                <b-form-input
                  id="form-input-filterByMaxDeliveryDays"
                  name="form-input-filterByMaxDeliveryDays"
                  v-validate="{ numeric: true, min_value: 1 }"
                  :state="validateState('form-input-filterByMaxDeliveryDays')"
                  v-model.number="itemForm.filterByMaxDeliveryDays"
                  type="number"
                  placeholder="Enter max delivery days (optional)"
                />
                <b-form-invalid-feedback id="form-input-filterByMaxDeliveryDays-feedback">
                  {{ veeErrors.first('form-input-filterByMaxDeliveryDays') }}
                </b-form-invalid-feedback>
                <b-form-text>Leave empty to include all delivery times</b-form-text>
              </b-form-group>
            </div>
          </b-row>

          <hr />

          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5>Rate Shop Mappings</h5>
            <b-button variant="success" @click="addMapping">
              <i class="fa fa-plus mr-1"></i>
              New Mapping
            </b-button>
          </div>

          <div v-if="itemForm.mappings && itemForm.mappings.length > 0">
            <div v-for="(mapping, index) in itemForm.mappings" :key="index" class="border p-3 mb-3 rounded">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0">Mapping {{ index + 1 }}</h6>
                <b-button variant="outline-danger" size="sm" @click="removeMapping(index)">
                  <i class="fa fa-trash"></i>
                </b-button>
              </div>
              
              <b-row>
                <b-col md="6">
                  <b-form-group label="TPL Carrier:">
                    <b-v-select
                      v-model="mapping.tplCarrierId"
                      :searchable="true"
                      :options="tplCarrierList"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="TPL Carrier Service:">
                    <b-v-select
                      v-model="mapping.tplCarrierServiceId"
                      :searchable="true"
                      :options="getFilteredServicesList(mapping.tplCarrierId)"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
          
          <div v-else class="text-center text-muted py-4">
            <p>No mappings added yet. Click "Add Mapping" to get started.</p>
          </div>
        </div>
      </b-card>
    </div>

    <div class="col-12 col-sm-3">
      <b-card header="Actions" no-body>
        <div class="card-body">
          <b-button
            variant="primary"
            block
            @click="SaveForm"
          >
            Save Changes
          </b-button>
          <b-button variant="outline-secondary" block @click="cancel">
            Cancel
          </b-button>
        </div>
      </b-card>
    </div>
  </b-row>
</template>

<script>
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Manage.BrandRateShops.Form',
  mixins: [crudMixinGen('storefrontRateShops'), myCommonDataMixin],

  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data() {
    return {
    };
  },

  computed: {
    tplCarrierList: {
      get() {
        let itmsList = [];
        let myItems = this.$store.getters.getMyTPL.carriers;
        itmsList.push({ value: '', text: 'Nothing' });
        myItems.forEach(itm => {
          itmsList.push({ value: itm.id, text: itm.name + ' (' + itm.description + ')' });
        });
        return itmsList;
      },
      set(val) {
      }
    },

  },

  mounted() {
    this.$store.dispatch('fetchMyTPLData');
    if (this.id) {
      this.ResetForm();
      this.LoadItem(this.id).then((resp) => {
      });
    } else {
      this.ResetForm();
    }
  },

  methods: {
    SaveForm() {
      this.SaveItem(this.itemForm)
        .then(resp => {
          this.savingItem = false;
          this.showItemForm = false;
          this.itemForm = Object.assign({}, resp.data);
          this.$swal({ title: 'Rate Shop Was Saved!', icon: 'success' });
          this.$router.push({
            name: 'Manage.BrandRateShops.Index'
          });
        })
        .catch(err => {
          this.savingItem = false;
          this.$swal('Error!', 'Form was Not Saved!', 'error');
            if (err.response && err.response.data.errorMessage) {
              this.$swal({ title: err.response.data.errorMessage, icon: 'error' });
            } else {
              this.$swal({ title: 'Rate Shop Was NOT Saved!', icon: 'error' });
            }
        });
    },
    getFilteredServicesList(carrierId) {
      let itmsList = [];
      let myItems = this.$store.getters.getMyTPL.shipmentServices;
      itmsList.push({ value: '', text: 'Nothing' });
      
      if (carrierId) {
        // Filter services by the selected carrier
        myItems
          .filter(service => service.tplCarrierId === carrierId)
          .forEach(itm => {
            itmsList.push({ value: itm.id, text: itm.description + ' (' + itm.code + ')' });
          });
      }
      
      return itmsList;
    },

    addMapping() {
      if (!this.itemForm.mappings) {
        this.$set(this.itemForm, 'mappings', []);
      }
      this.itemForm.mappings.push({
        fulfillmentCarrierCode: '',
        fulfillmentCarrierName: '',
        fulfillmentServiceCode: '',
        fulfillmentServiceName: '',
        tplCarrierId: null,
        tplCarrierServiceId: null
      });
    },

    removeMapping(index) {
      this.itemForm.mappings.splice(index, 1);
    },

    cancel() {
      this.$router.push({ name: 'Manage.BrandRateShops.Index' });
    }
  }
};
</script>